import { createReducer, INITIAL_STATE } from '@shared/redux';
import { LOAD_STATE } from '@shared/axios';
import { convertTaggedCampaignsToMap } from '@domain/segments/segments.utils';
import { configCreateOrUpdateSegments } from './segments-modal.api';
import { getSegmentWithTagEdited } from './segments-modal.utils';

const TOGGLE_SEGMENTS_MODAL = '@segments/segments-modal/TOGGLE_SEGMENTS_MODAL';
const SET_SEGMENT_MODAL = '@segments/segments-modal/SET_SEGMENT_MODAL';
const EDIT_SEGMENT_MODAL_TAGGED_CAMPAIGN = '@segments/segments-modal/EDIT_SEGMENT_MODAL_TAGGED_CAMPAIGN';
const EDIT_SEGMENT_MODAL_REQUEST_CALLED = '@segments/segments-modal/EDIT_SEGMENT_MODAL_REQUEST_CALLED';
export const EDIT_SEGMENT_MODAL_REQUEST_SUCCEEDED = '@segments/segments-modal/EDIT_SEGMENT_MODAL_REQUEST_SUCCEEDED';
export const EDIT_SEGMENT_MODAL_REQUEST_FAILED = '@segments/segments-modal/EDIT_SEGMENT_MODAL_REQUEST_FAILED';

export const toggleTagsGroupModal = () => ({
    type: TOGGLE_SEGMENTS_MODAL,
    payload: {},
});

export const setModalSelectedGroup = ({ group }) => ({
    type: SET_SEGMENT_MODAL,
    payload: {
        group,
    },
});

export const editModalSegmentedTaggedCampaign = ({ campaign, tag }) => ({
    type: EDIT_SEGMENT_MODAL_TAGGED_CAMPAIGN,
    payload: {
        campaign,
        tag,
    },
});

export const editModalSegmentsRequest = ({ segment, platform, clientId }) => ({
    type: EDIT_SEGMENT_MODAL_REQUEST_CALLED,
    actionTypes: {
        success: EDIT_SEGMENT_MODAL_REQUEST_SUCCEEDED,
        fail: EDIT_SEGMENT_MODAL_REQUEST_FAILED,
    },
    config: configCreateOrUpdateSegments({ segment, platform, clientId }),
    payload: {
        segment,
    },
});

const initialState = {
    isTagsGroupModalOpen: false,
    modalSelectedGroup: {},
    loadState: null,
    error: null,
};

export const segmentsModalReducer = createReducer({
    [INITIAL_STATE]: initialState,
    [TOGGLE_SEGMENTS_MODAL]: state => ({
        ...state,
        isTagsGroupModalOpen: !state.isTagsGroupModalOpen,
    }),
    [SET_SEGMENT_MODAL]: (state, action) => ({
        ...state,
        modalSelectedGroup: action.payload.group,
    }),
    [EDIT_SEGMENT_MODAL_TAGGED_CAMPAIGN]: (state, action) => ({
        ...state,
        modalSelectedGroup: getSegmentWithTagEdited(state.modalSelectedGroup,
            action.payload.campaign, action.payload.tag),
    }),
    [EDIT_SEGMENT_MODAL_REQUEST_CALLED]: state => ({
        ...state,
        loadState: LOAD_STATE.LOADING,
        error: null,
    }),
    [EDIT_SEGMENT_MODAL_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        modalSelectedGroup: {
            ...state.modalSelectedGroup,
            taggedCampaigns: convertTaggedCampaignsToMap(action.payload.data),
        },
        loadState: LOAD_STATE.SUCCESS,
        error: null,
    }),
    [EDIT_SEGMENT_MODAL_REQUEST_FAILED]: (state, action) => ({
        ...state,
        loadState: LOAD_STATE.FAIL,
        error: action.payload,
    }),
});
